$(function() {
	$('.more').click(function () {
        var text = $(this).text()
        if (text == '+ View more') {
          $('.desc-info').css({ maxHeight: '2000px' })
          $(this).text('- View less')
          $('.mh').hide()
        } else {
          $('.desc-info').css({ maxHeight: '90px' })
          $(this).text('+ View more')
          $('.mh').show()
        }
      })

  $(".eng-input").bind("input propertychange",function(event){
        var str = $(".eng-input").val();
        if(str.length >= 40){
            $(this).css("border","2px solid red");
        }else{
            $(this).css("border","2px solid #CCC");
        }
    });
});